export default "__VITE_ASSET__MFWaPIeg__"